import { TaxonomyLanguages } from 'app/types/editor-taxonomy';

// Single home for resolving a concept's human label
// `resolveConceptLabel` is the canonical fallback cascade.

export const resolveConceptLabel = ({ languages, currentLang }: { languages: TaxonomyLanguages; currentLang: keyof TaxonomyLanguages }): string | null => {
  const langObj = languages[currentLang] || languages['en'];
  let label: string | null = null;
  if (langObj) {
    label = langObj.label ?? langObj.terseLabel ?? langObj.verboseLabel ?? null;
  }
  if (label) {
    label = label.replace(/\s*\[.*?\]\s*/g, '').trim();
  }
  return label;
};

// The dominant call-site pattern: a concept's display label, falling back to the
// concept's own `name` only when it carries no `labels` at all. When `labels`
// exist but resolve to null, that null is returned (the name fallback does NOT
// apply) — matching the existing `concept?.labels ? resolve(...) : name || x` ternary.
export const resolveConceptLabelOrName = ({
  concept,
  currentLang,
  fallback = '-',
}: {
  concept: { labels?: TaxonomyLanguages | null; name?: string | null } | null | undefined;
  currentLang: keyof TaxonomyLanguages;
  fallback?: string;
}): string | null => {
  return concept?.labels ? resolveConceptLabel({ languages: concept.labels, currentLang }) : concept?.name || fallback;
};
